import React, { useState } from "react";
import { InjectedAccountWithMeta } from "@polkadot/extension-inject/types";
import Step from "./Step";
import StepButton from "./StepButton";
import { web3FromAddress } from "@polkadot/extension-dapp";
import { ApiPromise } from "@polkadot/api";
import { ethers } from "ethers";

interface Step4Props {
  currentStep: number;
  stepComplete: () => void;
  substrateAccount: InjectedAccountWithMeta | null;
  ethAddress: string;
  signature: string;
  substrateApi: ApiPromise | null;
}

const Step4: React.FC<Step4Props> = ({
  currentStep,
  stepComplete,
  substrateAccount,
  ethAddress,
  signature,
  substrateApi,
}) => {
  const [loading, setLoading] = useState(substrateApi ? true : false);

  return (
    <Step stepNum={4} currentStep={currentStep} title="Bind Accounts">
      <div className="flex flex-col justify-center items-start gap-2 py-3">
        <StepButton
          text="Bind Account"
          completedText="Account Bound"
          completed={currentStep > 4}
          onClick={async () => {
            if (substrateApi) {
              try {
                const injector = await web3FromAddress(
                  substrateAccount!.address
                );
                setLoading(true);

                const txs = [
                  substrateApi.tx.evmAccounts.claimAccount(
                    ethers.utils.arrayify(ethAddress),
                    signature
                  ),
                ];

                const unsub = await substrateApi.tx.utility
                  .batch(txs)
                  .signAndSend(
                    substrateAccount!.address,
                    {
                      signer: injector.signer,
                    },
                    async (result) => {
                      if (result.status.isInBlock) {
                        const evmAddress =
                          await substrateApi.query.evmAccounts.evmAddresses(
                            substrateAccount!.address
                          );

                        if (evmAddress.toString() === ethAddress) {
                          stepComplete();
                        } else {
                          throw Error("Bind not successful");
                        }

                        setLoading(false);
                        unsub();
                      }
                    }
                  );
              } catch (error) {
                console.log(error);
                console.error("Bind error");
                setLoading(false);
              }
            }
          }}
          disabled={currentStep !== 4}
          loading={loading}
        />
      </div>
    </Step>
  );
};

export default Step4;
